import http from '@/api/common'

export default {
  getGroup (groupID) {
    return http.get(`group/get?id=${groupID}`)
  },
  getGroupsByLocation (params, locationID = null) {
    return http.get(`group/getbylocation?locationID=${locationID}`, { params })
  },
  createGroup (group) {
    return http.post('group/create', group)
  },
  updateGroup (group) {
    return http.post('group/update', group)
  },
  deleteGroup (group) {
    return http.post('group/delete', group)
  },
  getTop5Buildings (groupId) {
    return http.get(`building/getTop5Buildings?groupId=${groupId}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/group.js